import { Component, Inject, OnInit } from '@angular/core';
import { ControlPointService } from 'src/app/services/control-point.service';
import { NgxUiLoaderService } from 'ngx-ui-loader';
import { CommonConstant } from 'src/app/core/constant/common.constant';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';

@Component({
    selector: 'app-update-kpi',
    templateUrl: './update-kpi.component.html',
    styleUrls: ['./update-kpi.component.scss'],
    standalone: false // NOSONAR
})
export class UpdateKpiComponent implements OnInit {
  heading: any;
  domicile: any;
  domicileList: any;
  errormsg: any;
  logisticsPoint = '01TMK';
  logisticsPointType;
  suppliersClosed;
  actualDroppedRoutes;
  namcExpedites;
  routesMissedUnload;
  ydParkingCapacity;
  parkingOccupied;
  cntgntTrailers;
  cntgntTrailersInUse;
  absenteeism;
  misconnects;
  comments;
  holdingData: any;
  fetchCPMDashboardData
  plantList: any;

  constructor(
    public dialogRef: MatDialogRef<UpdateKpiComponent>,
    private readonly service: ControlPointService,
    @Inject(MAT_DIALOG_DATA) public dataStore: any,
     private readonly  ngxUiLoaderService : NgxUiLoaderService,
  ) {}

  ngOnInit(): void {
    this.heading = this.dataStore.header;
    this.plantList = this.dataStore.domicleList;
    this.service.fetchCPMDashboardData().subscribe({
      next: (res: any) => {        
        this.fetchCPMDashboardData = res.cpmDataList
        this.refreshData()
        this.ngxUiLoaderService.stop(CommonConstant.loader);
      },
      error: (error) => {
        this.ngxUiLoaderService.stop(CommonConstant.loader);
        console.info(error);
      },
    });
  }

  refreshData() {
    this.holdingData = this.fetchCPMDashboardData.find(
      (item) => item.logisticsPoint == this.logisticsPoint                    // NOSONAR
    );
    this.logisticsPointType = this.holdingData?.logisticsPointType;
    this.suppliersClosed = this.holdingData?.suppliersClosed;
    this.actualDroppedRoutes = this.holdingData?.actualDroppedRoutes;
    this.namcExpedites = this.holdingData?.namcExpedites;
    this.routesMissedUnload = this.holdingData?.routesMissedUnload;
    this.ydParkingCapacity = this.holdingData?.ydParkingCapacity;
    this.parkingOccupied = this.holdingData?.parkingOccupied;
    this.cntgntTrailers = this.holdingData?.cntgntTrailers;
    this.cntgntTrailersInUse = this.holdingData?.cntgntTrailersInUse;
    this.absenteeism = this.holdingData?.absenteeism;
    this.misconnects = this.holdingData?.misconnects;
    this.comments = this.holdingData?.comments;
  }
  close(): void {
    this.dialogRef.close({ event: 'CloseEvent' });
  }

  saveClick() {
    this.ngxUiLoaderService.start(CommonConstant.loader);
    const updatedObject = {
      logisticsPoint: this.logisticsPoint,
      logisticsPointType: this.logisticsPointType,
      suppliersClosed: this.suppliersClosed,
      actualDroppedRoutes: this.actualDroppedRoutes,
      namcExpedites: this.namcExpedites,
      routesMissedUnload: this.routesMissedUnload,
      ydParkingCapacity: this.ydParkingCapacity,
      parkingOccupied: this.parkingOccupied,
      cntgntTrailers: this.cntgntTrailers,
      cntgntTrailersInUse: this.cntgntTrailersInUse,
      absenteeism: this.absenteeism,
      misconnects: this.misconnects,
      comments: this.comments,
    };

    this.service.updateCPMDashboard(updatedObject).subscribe({
      next: (_res: any) => {
        this.dialogRef.close({ event: 'objectUpdated',eventType: 'success' });
      },
      error: (_error) => {
        this.dialogRef.close({ event: 'objectUpdated',eventType: 'failure' });
      },
    });


  }
}
